/**
 * Регистрирует service worker из prod-сборки. Браузер сам проверяет новую версию sw.js при переходах,
 * а при возврате в уже открытое приложение проверку запускаем вручную.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    // updateViaCache: "none" — sw.js всегда сверяется с сервером, мимо HTTP-кэша.
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .then((registration) => {
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") registration.update().catch(() => {});
        });
      })
      .catch(() => {
        // Без worker'а приложение работает как обычный сайт, только без офлайн-shell.
      });
  });
}
